<template>
  <div class="header-component">
    <span>Dashboard</span>
    <primary-select :options="[1,2,3,4,5]"
                    class="select"
                    v-model="first" />
    <primary-select :options="[1,2,3,4,5]"
                    class="select"
                    v-model="second" />
  </div>
</template>

<script>
export default {
  components: {
    PrimarySelect: () => import('../Inputs/PrimarySelect.vue'),
    data: () => ({
      first: 'Overall system',
      second: 'Last 30 days'
    }),
  },
}
</script>

<style lang="scss" scoped>
.header-component {
  margin-left: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  span {
    margin-right: 32px;
    color: #55616e;
    font-size: 18px;
    font-weight: 900;
    line-height: 30px;
  }
  .select {
    max-width: 180px;
    margin-right: 15px;
  }
}
</style>

